










import { Component, Vue } from 'vue-property-decorator';
import LastEdition from '@/components/lastEdition.vue';
import h1Wrapper from '@/components/common/h1.vue';
import ContentText from '@/components/common/contentText.vue';
import { ContentModuleMapper } from '@/store/modules/content';
import { MenuModuleMapper } from '@/store/modules/menu';
import { ConstantsModuleMapper } from '@/store/modules/constants';
import { ConfigsModuleMapper } from '@/store/modules/config';

@Component({
  components: {
    LastEdition,
    h1Wrapper,
    ContentText,
  },
  computed: {
    ...ConstantsModuleMapper.mapState([
      'list',
    ]),
    ...MenuModuleMapper.mapGetters(['menuItemNumber']),
    ...ContentModuleMapper.mapState(['data']),
    ...ContentModuleMapper.mapGetters(['content']),
    ...ConfigsModuleMapper.mapState([
      'returnFromSearch',
    ]),
  },
})
export default class ArticleComponent extends Vue {
  get version() {
    // @ts-ignore
    return this.menuItemNumber(this.$route.path);
  }

  onBack(event: Event) {
    event.preventDefault();
    window.history.back();
  }
}
